<canvas class="fixed top-0 left-0 w-screen h-screen overflow-hidden" id="c"></canvas>

<div class=" fixed top-0 left-0 w-screen h-screen flex flex-col z-10 items-center px-5 ">

    <div class="flex flex-row justify-end items-center py-5 w-full top-0 left-0 absolute px-5">
        <div [@child15] appClickOutside (clickOutside)="closeDropdown('showLangage')"
            [ngClass]="(language | language )?'rtl':'ltr'">
            <i (click)="showLangage = !showLangage"
                class="fa-light fa-earth-americas leading-9 w-9 h-9 text-center bg-zen bg-opacity-10 rounded text-zen btn"></i>
            <div class="flex left-0 flex-row justify-end absolute w-full h-0 px-5">
                <div [@fadeUpDown] *ngIf="showLangage"
                    class="flex flex-col gap-1 top-22 px-2 py-2 rounded-lg shadow-lg bg-white  mt-5 topArrow relative h-max w-32">
                    <ng-container *ngFor="let lang of supportedLanguages">
                        <a *ngIf="lang.key != language"
                            (click)="selectedLanguageChange(lang.key); closeDropdown('showLangage')"
                            class="text-zen text-sm btn rounded-sm cancel py-2 px-2">
                            {{lang.name}}</a>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="flex flex-col items-center justify-center h-full w-full gap-10">
        <div class="flex flex-row justify-center">
            <img *ngIf="(!logoLoading && tenantKeyExists)" style="width: 300px; " [src]="tenantLogo" />
            <img *ngIf="(!tenantKeyExists)" style="width: 300px;" [src]="logoURL" />
        </div>
        <div
            class="flex flex-col items-center  rounded-xl p-5 max-w-lg w-full backdrop-filter backdrop-blur bg-white bg-opacity-30">
            <div [@inOutAnimation] class="flex flex-col items-center w-full gap-5" *ngIf="section != 'sent'">
                <span [@inOutAnimation] class="flex flex-col items-center" *ngIf="section == 'login'">
                    <h5 class="text-lg text-zen">{{'txtResetPassword'| translate:language:ModuleNames.Common}}</h5>
                    <h5 class="text- text-zen font-light">
                        {{'txtTypeAStrongPasswrod'|translate:language:ModuleNames.Common}}</h5>

                </span>




                <div class="flex flex-col items-center w-full  gap-2" [@inOutAnimation] *ngIf="section == 'login'">
                    <z-input customClass="h-12 text-lg" class="text-zen w-full" [language]="language"
                        [placeholder]="'txtPassword' | translate:language:ModuleNames.Common" [password]="true"
                        [(ngModel)]="password" [required]="true"></z-input>
                    <z-input customClass="h-12 text-lg" class="text-zen w-full" [language]="language"
                        [placeholder]="'txtConfirmPassword' | translate:language:ModuleNames.Common" [password]="true"
                        [(ngModel)]="confirmPassword" [required]="true"></z-input>
                    <h5 *ngIf="submitted" class="text-xs text-zen-red text-start w-full">
                        <span
                            *ngIf="password != confirmPassword">{{'txtPasswordsAreNotSimilar'|translate:language:ModuleNames.Common}} <br></span>
                        <span
                            *ngIf="password.length < 8">{{'txtPasswordShouldBeMin'|translate:language:ModuleNames.Common}} <br> </span>
                    </h5>
                    <a class="btn exp uppercase leading-15 px-5 rounded-lg" (click)="resetPassword()">{{'txtReset'|
                        translate:language:ModuleNames.Common}}</a>
                </div>


            </div>

        </div>
    </div>


</div>